import { useAuth } from "@/lib/auth";
import { Download } from "lucide-react";

/**
 * Triggers a CSV download via the backend export endpoint.
 * type: "products" | "companies" | "quotes" | "orders" | "stock-movements" | "cari-movements" | "aging"
 */
export default function ExportButton({ type, params = {}, label = "CSV İndir", testid, format = "csv", icon }) {
  const { token } = useAuth();
  const onClick = () => {
    const t = token();
    const url = new URL(`${process.env.REACT_APP_BACKEND_URL}/api/export/${type}`);
    url.searchParams.set("auth", t);
    if (format && format !== "csv") url.searchParams.set("format", format);
    Object.entries(params).forEach(([k, v]) => v != null && url.searchParams.set(k, v));
    window.open(url.toString(), "_blank");
  };
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testid || `export-${type}-${format}`}
      className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg bg-white border border-[#E5E7EB] hover:border-[#0B3676] text-xs font-semibold text-[#08285A] transition-colors"
    >
      {icon || <Download size={14} />}
      {label}
    </button>
  );
}
